import React, { ReactNode, useEffect } from 'react';
import { connect, shallowEqual, useSelector } from 'dva';
import styles from './app.less';
import { GlobalState } from '@/models/types';

interface IAppProps {
  children: ReactNode;
}

const App: React.FC<IAppProps> = ({ children }) => {
  const pathname = useSelector((state: GlobalState) => state.router.location.pathname, shallowEqual);
  useEffect(() => {
    window.scrollTo(0, 0)
    window._czc?.push(["_trackEvent", 'page', pathname])
  }, [pathname])

  return (
    <div className={styles.layout} id="layoutWrap">
      {children}
    </div>
  );
};


export default connect()(App);
